var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('solution-new',{staticStyle:{"padding-top":"60px"},attrs:{"sub-title-show":false}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v("中惠科技 让工程更智慧")]),_vm._v(" "),_c('p',[_vm._v("领先的工程建设SAAS服务提供商")])])
}]

export { render, staticRenderFns }